export default __webpack_public_path__ + "static/media/drivability-checker.ee72c29d.md";